import { User } from './user';

export class BaseModel {
    Id: number;
    Path?: string;
    Active = true;
    Deleted = false;
    CreatedAt?: string;
    CreatedBy?: User;
    UpdatedAt?: string;
    UpdatedBy?: User;
    LastTimestamp?: string;

    id?: number;
}
